import request from '@/utils/request'

export function getProductList (data) {
  return request({
    url: 'goods/list',
    method: 'get',
    params: data
  })
}

export function getDetail (data) {
  return request({
    url: 'goods/detail',
    method: 'get',
    params: data
  })
}
